import { render, staticRenderFns } from "./SuppAdd.vue?vue&type=template&id=613feb7d&scoped=true&"
import script from "./SuppAdd.vue?vue&type=script&lang=js&"
export * from "./SuppAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613feb7d",
  null
  
)

export default component.exports